import { Cart, CartState } from "./cart-types";
import { cart_init_state } from "./cart-constants";
import { RERIEVE_CART } from "./cart-actionTypes";

// import globalTypes from "../global/types";

function cartReducer(state = cart_init_state, action) {
  switch (action.type) {
    case RERIEVE_CART:
      return retrive_cart_reducer(state, action.payload);
    // case globalTypes.LOGOUT:
    //   return retrive_cart_reducer(state, action.payload);
    default:
      return state;
  }
}

function retrive_cart_reducer(state: CartState, payload: Cart): CartState {
  return {
    ...state,
    data: payload,
  };
}

export default cartReducer;
